import { urlBuilder } from '@/connectors/endpoints'
import { mapper } from '@/mappers'
import reverseObjUtil from '@/utils/reverse-obj.util'
import { ICreateEmployee, IEmployee } from '@/types/employees'
import { createEmployeeMap } from '@/mappers/employees'
import AxiosRequestBuilder from '@/utils/axios-request-builder'

const addEmployee = (formData: ICreateEmployee, endPoint: string) => {
  return new AxiosRequestBuilder<IEmployee>({
    url: urlBuilder(endPoint),
    method: 'post',
    data: formData,
    requestMapperFunction: mapper,
    requestMapper: reverseObjUtil(createEmployeeMap)
  }).exec()
}

export default addEmployee
